module.exports = __webpack_public_path__ + "img/afternoon_study1_sm.3b8e38c8.png";